import type { AnswerSelectionMode } from "@quizshow/protocol";

export function toggleAnswerSelection(
  selected: string[],
  optionId: string,
  selectionMode: AnswerSelectionMode,
): string[] {
  if (selectionMode === "single") {
    return selected.includes(optionId) ? [] : [optionId];
  }
  return selected.includes(optionId)
    ? selected.filter((selectedId) => selectedId !== optionId)
    : [...selected, optionId];
}
